import { useListBookings } from '@/queries/bookings.queries';
import { Box, Progress, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Temporal } from 'temporal-polyfill';

export function PlanUsage() {
	const today = Temporal.Now.zonedDateTimeISO().round('day');
	const from = today.with({ day: 1 }).toInstant().toString();
	const days = today.daysInMonth;
	const bookingsQuery = useListBookings({ days, from });

	if (!bookingsQuery.data) {
		return null;
	}

	const myBookings = bookingsQuery.data.filter((booking) => !booking.cancellation);

	return (
		<Box mt="auto" py={4} px={4} bg="gray.50" borderTopWidth={1} borderTopColor="gray.200">
			<Text fontWeight={500}>{t('Bookings this month')}</Text>
			<Progress my={1} colorScheme="primary" size="sm" borderRadius="md" value={myBookings.length} min={0} max={20} />
			<Text fontSize="xs">{myBookings.length} / 20</Text>
		</Box>
	);
}
